import { type FC, useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { FileUpload } from "@/components/FileUpload";
import { Spinner } from "@/components/ui/spinner";

interface ModalRequireEditDocProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (data: { reason: string; file: string }) => void;
    isLoading?: boolean;
    defaultReason?: string;
    defaultFile?: string;
    title?: string;
}

export const ModalRequireEditDoc: FC<ModalRequireEditDocProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading = false,
    defaultReason = "",
    defaultFile = "",
    title = "ຂໍແກ້ໄຂເອກະສານ"
}) => {
    const [reason, setReason] = useState(defaultReason);
    const [file, setFile] = useState(defaultFile);

    useEffect(() => {
        if (isOpen) {
            setReason(defaultReason);
            setFile(defaultFile);
        }
    }, [isOpen, defaultReason, defaultFile]);

    const handleConfirm = () => {
        onConfirm({ reason, file });
    };

    return (
        <Dialog open={isOpen} onOpenChange={() => { }} modal={true}>
            <DialogContent
                className="sm:max-w-[500px] [&>button]:hidden"
                onInteractOutside={(e) => {
                    // ປ້ອງກັນການປິດເມື່ອຄລິກຂ້າງນອກ
                    e.preventDefault();
                }}
                onEscapeKeyDown={(e) => {
                    // ປ້ອງກັນການປິດເມື່ອກົດ Escape
                    e.preventDefault();
                }}
            >
                <DialogHeader>
                    <div className="flex justify-between items-center">
                        <DialogTitle>{title}</DialogTitle>
                        {/* Close button provided by Dialog primitive usually, but explicit close is fine if needed. DialogContent usually has a close X. */}
                    </div>
                    <DialogDescription>
                        ກະລຸນາໃສ່ເຫດຜົນ ແລະ ອັບໂຫຼດເອກະສານຢັ້ງຢືນ.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="flex flex-col gap-2">
                        <Label htmlFor="reason">ເຫດຜົນ <span className="text-red-500">*</span></Label>
                        <Textarea
                            id="reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="ປ້ອນເຫດຜົນ..."
                            className="resize-none"
                            rows={4}
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        {/* <Label>ເອກະສານແນບ <span className="text-red-500">*</span></Label> */}
                        <FileUpload
                            currentFile={file}
                            onFileUpload={setFile}
                        // isSubmitting={isLoading}
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose} type="button" disabled={isLoading}>ຍົກເລີກ</Button>
                    <Button onClick={handleConfirm} disabled={isLoading || !reason || !file} type="button">
                        {isLoading && <Spinner className="mr-2 h-4 w-4 animate-spin" />}
                        ບັນທຶກ
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};